import { render, staticRenderFns } from "./NewsCategoryForm.vue?vue&type=template&id=1a004f30&"
import script from "./NewsCategoryForm.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports